import { Box, Paper, Typography } from '@mui/material';
import { format } from 'date-fns';

interface Message {
  id: number;
  from_admin: boolean;
  admin_username?: string;
  text: string;
  created_at: string;
}

interface MessageListProps {
  messages: Message[];
}

export const MessageList = ({ messages }: MessageListProps) => {
  return (
    <Box sx={{ maxHeight: '500px', overflowY: 'auto', p: 2 }}>
      {messages.length === 0 ? (
        <Typography variant="body2" color="text.secondary" align="center">
          No messages yet
        </Typography>
      ) : (
        messages.map((msg) => <MessageBubble key={msg.id} message={msg} />)
      )}
    </Box>
  );
};

const MessageBubble = ({ message }: { message: Message }) => {
  const isAdmin = message.from_admin;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isAdmin ? 'flex-end' : 'flex-start',
        mb: 2
      }}
    >
      <Box sx={{ maxWidth: '70%' }}>
        <Paper
          sx={{
            p: 2,
            bgcolor: isAdmin ? 'primary.main' : 'grey.800',
            color: 'white',
            borderRadius: isAdmin ? '12px 12px 0 12px' : '12px 12px 12px 0'
          }}
        >
          {isAdmin && message.admin_username && (
            <Typography variant="caption" sx={{ fontWeight: 'bold', mb: 0.5, display: 'block' }}>
              {message.admin_username}
            </Typography>
          )}
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
            {message.text}
          </Typography>
          <Typography variant="caption" sx={{ mt: 1, display: 'block', opacity: 0.7 }}>
            {format(new Date(message.created_at), 'HH:mm • MMM dd')}
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};
